module.exports = __webpack_public_path__ + "src/assets/sounds/main_theme.mp3";